module.exports = __webpack_public_path__ + "img/server-dashboard.daf5027f.png";